<div class="page-container mt-3" id="verifyOtpModal">
  <button
    type="button"
    class="btn-close otp-close-btn rounded-3 position-absolute top-0 end-0 m-3"
    aria-label="Close"
    (click)="closeModal()"
    [disabled]="isLoading"
  ></button>
  <div class="row">
    <div class="col-md-12">
      <div class="d-flex flex-column align-items-start">
        <p class="txt--otp-title mt-4 fw-bold">
          {{ "common.enterYourOtp" | translate }}
        </p>
        <p class="txt--otp-desc">{{ "msg.otp.enter" | translate }}</p>
        <div class="w-100 text-center">
          <ng-otp-input
            name="otp"
            ngDefaultControl
            [config]="otpSettings"
            [(ngModel)]="otp"
            (onInputChange)="onInputChange($event)"
          ></ng-otp-input>
          <div
            class="mt-3 d-flex justify-content-between align-items-center flex-column flex-sm-row align-items-start align-items-sm-center"
          >
            <ng-container *ngIf="counter > 0">
              {{ "common.timeRemaining" | translate }}: {{ counter }}
            </ng-container>
          </div>
          <span *ngIf="message" class="text-danger">
            {{ message }}
          </span>
          <div class="my-3">
            <button
              (click)="otpExpired ? requestSecondaryOtp() : verifyOtp()"
              [ngClass]="{
                disabled: (verifyBtnDisabled || isLoading) && !otpExpired,
              }"
              [disabled]="(verifyBtnDisabled || isLoading) && !otpExpired"
              class="btn btn-verify width-100 cursor-pointer rounded-3"
            >
              {{
                (otpExpired ? "common.resendOTP" : "common.submit") | translate
              }}
              <ng-container *ngIf="isLoading">
                <span class="spinner-border spinner-border-sm me-2"></span>
              </ng-container>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
